"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _pollDownloadUrl = require("@insided/shared/uikit/Editor/Attachments/pollDownloadUrl");

var _FileAttachmentLink = _interopRequireDefault(require("./FileAttachmentLink"));

var _FileAttachmentSkeleton = _interopRequireDefault(require("./FileAttachmentSkeleton"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FileAttachmentTile = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FileAttachmentTile, _Component);

  var _super = _createSuper(FileAttachmentTile);

  function FileAttachmentTile() {
    var _this;

    (0, _classCallCheck2.default)(this, FileAttachmentTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "abortController", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pollTimer", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deadline", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      status: 'checking'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "probe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.abortController = new AbortController();
              _context.prev = 1;
              _context.next = 4;
              return fetch(_this.props.href, {
                method: 'HEAD',
                signal: _this.abortController.signal
              });

            case 4:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 8;
                break;
              }

              _this.setState({
                status: 'clean'
              });

              return _context.abrupt("return");

            case 8:
              if (!(Date.now() < _this.deadline)) {
                _context.next = 12;
                break;
              }

              _this.setState({
                status: 'pending'
              });

              _this.pollTimer = setTimeout(_this.probe, _pollDownloadUrl.POLL_INTERVAL);
              return _context.abrupt("return");

            case 12:
              // Timed out. Fall back to rendering the link so the user at least has
              // something to click — no worse than the pre-fix behavior.
              _this.setState({
                status: 'clean'
              });

              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](1);

              if (!((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.name) === 'AbortError')) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              // CORS block or network error — we can't probe this URL. Render the
              // link so the user can still try it (may succeed; may 403 briefly).
              _this.setState({
                status: 'clean'
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 15]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(FileAttachmentTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.deadline = Date.now() + _pollDownloadUrl.POLL_TIMEOUT;
      this.probe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$abortController;

      (_this$abortController = this.abortController) === null || _this$abortController === void 0 ? void 0 : _this$abortController.abort();
      if (this.pollTimer !== null) clearTimeout(this.pollTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          filename = _this$props.filename,
          type = _this$props.type,
          FileTypeIcon = _this$props.FileTypeIcon;

      switch (this.state.status) {
        case 'checking':
        case 'pending':
          return (0, _preact.h)(_FileAttachmentSkeleton.default, {
            icon: FileTypeIcon && (0, _preact.h)(FileTypeIcon, {
              className: "icon--file",
              style: {
                opacity: 0.4
              }
            }),
            label: (0, _preact.h)(_phrase.default, {
              m: "Common",
              p: "js.attachments.pending.title"
            })
          });

        case 'clean':
        default:
          return (0, _preact.h)(_FileAttachmentLink.default, {
            href: (0, _absoluteUrlRuntime.resolveUrl)(href),
            filename: filename,
            type: type,
            icon: FileTypeIcon && (0, _preact.h)(FileTypeIcon, {
              className: "icon--file"
            })
          });
      }
    }
  }]);
  return FileAttachmentTile;
}(_preact.Component);

var _default = FileAttachmentTile;
exports.default = _default;